(function($) {
    $(document).ready(function() {

        // Woo doesn't highlight the nav to being active, let's fix that
        var pathname = String(window.location.pathname).replace(/^\/|\/$/g, '');

        if ( pathname.match( /^my-account\/view-subscription\/\d+$/ ) || pathname.match( /^my-account\/subscriptions/ ) ) {
            $( '.woocommerce-MyAccount-navigation-link--subscription-details' ).addClass( 'is-active' );
        }

        // Wrap the order of the button to the bottom
        $( '.woocommerce-MyAccount-content .woocommerce-Address').each(function() {
            $(this).append(
                $(this).find('header a').addClass('button')
            );
        } );

        // Create a mobile navigation using a select item
        (function() {

            var navigation = $( '.woocommerce-MyAccount-navigation' );

            if( ! navigation.length ) {
                return;
            }

            var select = $(document.createElement('select')).addClass('woocommerce-MyAccount-navigation-select').on('change',function() {
                if( ! $(this).val() ) {
                    return;
                }
                window.location.href = $(this).val();
            });

            navigation.find( 'li' ).each(function() {
                select.append(
                    $( document.createElement('option') )
                        .attr( 'selected', $(this).hasClass('is-active') )
                        .attr( 'value', $(this).find( 'a' ).prop('href') )
                        .text( $(this).find( 'a' ).text() )
                );
            });

            navigation.after( select );

        })();

        // Make the orders table rows all one liners
        $( '.woocommerce-orders-table .woocommerce-orders-table__cell-order-actions').each( function () {
            var actions = $( this ).find( 'a' );
            if ( actions.length>1 ) {
                var select = $('<select class="" onchange="if (this.value) window.location.href=this.value" />')
                    .append( $('<option />').html( 'Go To ...' ) );
                actions.each( function ( index ) {
                    var anchor = $( this );
                    select.append( $('<option />').attr('value', anchor.prop( 'href' ) ).html( anchor.html() ) );
                } ).hide();
                $( this ).append( select );
            }
        } );

        // Close download modal
        $( '#download-cta .dismiss' ).on('click',function (e) {
            e.preventDefault();

            localStorage.setItem( 'acrobat-cta-dismissed', true );
            $.jqmodal.close();

            return false;
        } );


        // Open subscription status modal if not dismissed
        if ( localStorage.getItem( 'subscription-cta-dismissed' ) === null ) {
            $( '#subscription-cta' ).jqmodal( {
                blockerClass: 'download-cta'
            } );
        }

        // Close the subscription modal
        $( '#subscription-cta .dismiss' ).on('click',function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            localStorage.setItem( 'subscription-cta-dismissed', true );
            $.jqmodal.close();

            return false;
        } );

        // On my subscription view, skip remainder of items here
        if( $('.woocommerce-account .woocommerce-MyAccount-content .account-my-subscription').length ) {
            return;
        }

        // Intercept download links with a jqmodal
        $('[href*="/my-download/"]').click(function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            $(this).trigger('my-download');
            window.location.href = $(this).attr('href');

            if ( $(this).is('.pdf') && localStorage.getItem( 'acrobat-cta-dismissed' ) === null ) {
                $( '#download-cta' ).jqmodal( {
                    blockerClass: 'download-cta'
                } );
            }

        });

        // Add pop up video player to video links
        $(".me-pro-download a.video").on('click',function(e) {
            $(this).trigger('my-download');
        }).YouTubePopUp( { autoplay: 1 } );

    });
})(jQuery);
